<template>
      <van-dialog class="bg" width="1000" v-model="show" title="编辑咖啡豆" :show-cancel-button="false"  :show-confirm-button="false">
        <div class="line">
          <van-cell-group inset>
            <!-- 输入任意文本 -->
            <van-field v-model="coffeeName" type="text" label="咖啡豆名称" 
              placeholder="必填，可输入32个汉字或64个英文字符" />
          </van-cell-group>
        </div>
        <div class="wrap">
          <div class="column">
            <div class="small-title">
              基础信息
            </div>
            <van-cell-group inset>
              <van-field v-model="info.kind" type="text"  label="豆种" />
              <van-field v-model="info.country" type="text"  label="国家" />
              <van-field v-model="info.prodRegion" type="text"  label="产区" />
              <van-field v-model="info.region" type="text"  label="地区" />
              <van-field v-model="info.estate" type="text"  label="庄园" />
            </van-cell-group>
          </div>
          <div class="column">
            <div class="small-title">
              烘培程度
            </div>
            <van-radio-group v-model="info.deep">
              <van-cell-group inset>
                <van-cell :title="item.value" clickable @click="changeDeep(item.key)" v-for="item in constantDeep">
                  <template #right-icon>
                    <van-radio :name="item.key" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
          <div class="column">
            <div class="small-title">
              处理方式
            </div>
            <van-radio-group v-model="info.method">
              <van-cell-group inset>
                <van-cell :title="item.value" clickable @click="changeMethod(item.key)" v-for="item in constantMethods">
                  <template #right-icon>
                    <van-radio :name="item.key" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </div>
          <div class="column">
            <div class="small-title">
              补充信息
            </div>
            <van-cell-group inset>
              <van-field v-model="info.customMethod" v-if="info.method == 9" type="text"  label="其他处理方式" />
              <van-field v-model="info.batch" type="text"  label="批次" />
              <van-field v-model="info.density" type="text"  label="密度" />
              <van-field v-model="info.water" type="text"  label="含水率" />
              <van-field v-model="info.waterActivity" type="text"  label="水活性" />
              <van-field v-model="info.color" type="text"  label="豆色值" />
              <van-field v-model="info.pink" type="text"  label="粉色值" />
            </van-cell-group>

          </div>
        </div>
        <div class="line">
          <van-cell-group inset>
            <!-- 输入任意文本 -->
            <van-field v-model="info.remarks" type="textarea" autosize label="备注" />
          </van-cell-group>
        </div>
        <div class="btn-box">
            <van-button  @click="close(false)" square>取消</van-button>
            <van-button color="#489D80" square  @click="save">保存</van-button>
        </div>
      </van-dialog>
  </template>
  
  <script>
    import { apiBeansEdit } from '../../request/api'
    import { Dialog, Toast, Field, CellGroup,Cell, Radio,RadioGroup } from 'vant';

    export default {
      components: {
        [Dialog.Component.name]: Dialog.Component,
        [Field.name]: Field,
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
        [RadioGroup.name]: RadioGroup,
        [Radio.name]: Radio,
      },
      name: 'Index',
      props: {
        show: Boolean,
        info: Object,
      },
      data() {
        return {
          loading: false,
          constantDeep: null,
          constantMethods: null,
          coffeeName: null,
        }
      },
      mounted() {
        this.init()
      },
      methods: {
        init() {
          this.getConstantDeep()
          this.getConstantMethods()
          this.coffeeName = JSON.parse(JSON.stringify(this.info.name))
        },
        onBeforeClose(action, done){
          console.log("beforeClose")
          console.log(action)
          console.log(done)
          if (action === 'confirm') {
            setTimeout(done(true), 1000);
          } else {
            done();
          }
        },
        save() {
          if(!this.coffeeName){
            Toast.fail('请输入咖啡豆名称')
            return
          }
          let self = this
          console.log(self.info)
          let params = {
            uuid: self.info.uuid,
            name: self.coffeeName,
            kind: self.info.kind,
            batch: self.info.batch,
            density: self.info.density,
            country: self.info.country,
            prodRegion: self.info.prodRegion,
            region: self.info.region,
            estate: self.info.estate,
            method: self.info.method,
            customMethod: self.info.customMethod,
            deep:  self.info.deep,
            water:  self.info.water,
            waterActivity:  self.info.waterActivity,
            color:  self.info.color,
            pink:  self.info.pink,
            remarks: self.info.remarks,
            date: self.info.date,
          }

        // 数字处理
        if(params.water){
          params.water = parseFloat(params.water)
        }
        if(params.density){
          params.density = parseFloat(params.density)
        }
        if(params.waterActivity){
          params.waterActivity = parseFloat(params.waterActivity)
        }
        if(params.color){
          params.color = parseFloat(params.color)
        }
        if(params.pink){
          params.pink = parseFloat(params.pink)
        }
          console.log(params)
          // 去除空值
          for (let key in params) {
            if (params[key] == '' || params[key] == null) {
              delete params[key]
            }
          }
          console.log(params)
          apiBeansEdit(params).then(res => {
            if(res.code == 0){
              Toast.success('保存成功')
              self.close(true)
            }else{
              Toast.fail(res.msg)
            }
          }).catch(err => {
            console.log(err)
          })
        },
        close(value){
          console.log(value)
          this.$emit('close', value )
        },
        changeMethod(value){
          this.info.method = value
        },
        changeDeep(value){
          this.info.deep = value
        },
        // 基础信息
      getConstantDeep(){
        let deep = localStorage.getItem('constantDeep')
        if(deep && deep.length > 0){
          // 字符串转换为json
          this.constantDeep = JSON.parse(deep)
        }else{
          setTimeout(() => {
            this.getConstantDeep()
          }, 500);
        } 
      },
      getConstantMethods(){
        let methods = localStorage.getItem('constantMethods')
        if(methods && methods.length > 0){
          this.constantMethods = JSON.parse(methods) 
        }else{
          setTimeout(() => {
            this.getConstantMethods()
          }, 500);
        }
      },
      }
    }
  </script>
  
  <style scoped>
  .bg {
    background-color: #efefef;
  }
  .wrap{
    display: flex;
    flex-direction: row;
    margin: 15px 0;
  }
  .column{
    width: 100%;
    flex:1,
  }
  .line{
    margin: 15px 0;
  }
  .van-radio {
    margin-bottom: 6px;
  }
  /*  */

  .btn-box{
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  .btn-box .van-button{
    flex: 1;
  }

  .small-title{
    font-size: 13px;
    color: #999;
    margin-bottom: 6px;
    margin-left: 20px;
  }
  </style>